export default __webpack_public_path__ + "locales/lo-LA/Webhooks.json?hash=685fc545ba61cf50f8371cd1726a9960";